import React from "react";

import { Link } from "react-router-dom";
import GroupIcon from "@mui/icons-material/Group";
import LoginIcon from "@mui/icons-material/Login";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import AdminPanelSettingsIcon from "@mui/icons-material/AdminPanelSettings";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import AssessmentIcon from "@mui/icons-material/Assessment";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import FunctionsIcon from '@mui/icons-material/Functions';

import logoNavbar from "../../assets/img/logoNavbar.jpeg";
import NavMenuItem from "./NavMenuItem";

import { useSelector } from "react-redux";

import {
	selectIsAdmin,
	selectIsAuthenticated,
	selectPermissaoCadastrar,
} from "../../storeConfig/reducers/loginReducer";

function NavBarMobile({ logout }) {
	const isAdmin = useSelector(selectIsAdmin);
	const isAuthenticated = useSelector(selectIsAuthenticated);
	const PermissaoCadastrar = useSelector(selectPermissaoCadastrar);

	const [anchorElNav, setAnchorElNav] = React.useState(null);

	const handleOpenNavMenu = (event) => {
		setAnchorElNav(event.currentTarget);
	};

	const handleCloseNavMenu = () => {
		setAnchorElNav(null);
	};

	return (
		<>
			{/* Menu Mobile */}
			<Box
				sx={{
					flexGrow: 1,
					display: { xs: "flex", md: "none" },
				}}
			>
				<IconButton
					size="large"
					aria-label="account of current user"
					aria-controls="menu-appbar"
					aria-haspopup="true"
					onClick={handleOpenNavMenu}
					color="primary"
				>
					<MenuIcon />
				</IconButton>
				<Menu
					id="menu-appbar"
					anchorEl={anchorElNav}
					anchorOrigin={{
						vertical: "bottom",
						horizontal: "left",
					}}
					keepMounted
					transformOrigin={{
						vertical: "top",
						horizontal: "left",
					}}
					open={Boolean(anchorElNav)}
					onClose={handleCloseNavMenu}
					sx={{
						display: { xs: "block", md: "none" },
					}}
				>
					{!isAuthenticated && (
						<div>
							<NavMenuItem
								onClick={handleCloseNavMenu}
								Icon={<LoginIcon />}
								page="Login"
								to="/login"
							/>
							<NavMenuItem
								onClick={handleCloseNavMenu}
								Icon={<HowToRegIcon />}
								page="Cadastre-se"
								to="/cadastre-se"
							/>
						</div>
					)}

					{isAuthenticated && (
						<div>
							<NavMenuItem
								onClick={handleCloseNavMenu}
								Icon={<FunctionsIcon />}
								page="Calcular"
								to="/form"
							/>
							<NavMenuItem
								onClick={handleCloseNavMenu}
								Icon={<AccountCircleIcon />}
								page="Perfil"
								to="/perfil"
							/>
							<NavMenuItem
								onClick={handleCloseNavMenu}
								Icon={<AssessmentIcon />}
								page="Resultados"
								to="/meus-resultados"
							/>
							{isAdmin && (
								<NavMenuItem
									onClick={handleCloseNavMenu}
									Icon={<AdminPanelSettingsIcon />}
									page="Administrador"
									to="/admin"
								/>
							)}
							{PermissaoCadastrar && (
								<NavMenuItem
									onClick={handleCloseNavMenu}
									Icon={<AdminPanelSettingsIcon />}
									page="Gestor"
									to="/gestor"
								/>
							)}
							<NavMenuItem
								onClick={logout}
								Icon={<ExitToAppIcon />}
								page="Sair"
								to="/"
							/>
						</div>
					)}

					<NavMenuItem
						onClick={handleCloseNavMenu}
						Icon={<GroupIcon />}
						page="Sobre Nós"
						to="/sobre"
					/>
				</Menu>
			</Box>

			{/* Logo Mobile */}
			<Box
				noWrap
				sx={{
					mr: 2,
					display: { xs: "flex", md: "none" },
					flexGrow: 1,
					fontFamily: "monospace",
					fontWeight: 700,
					letterSpacing: ".3rem",
					color: "primary",
					textDecoration: "none",
				}}
			>
				<Link to="/" className="navbar-brand justify-content-center">
					<img
						className="image-fluid"
						width="100px"
						src={logoNavbar}
						alt="Logo do SGIO"
					/>
				</Link>
			</Box>
		</>
	);
}

export default NavBarMobile;
